import { GlobalActionTypes, GlobalActions } from './types'

export const setIsIssuingCard = (isIssuingCard: boolean): GlobalActionTypes => ({
    type: GlobalActions.SET_IS_ISSUING_CARD,
    payload: isIssuingCard
})

export const setIsServicable = (isServicable: boolean): GlobalActionTypes => ({
    type: GlobalActions.SET_IS_SERVICABLE,
    payload: isServicable
})

export const setIsUpdateAvailable = (isAvailable: boolean, isCritical: boolean): GlobalActionTypes => ({
    type: GlobalActions.SET_IS_UPDATE_AVAILABLE,
    payload: {
        isAvailable,
        isCritical
    }
})

export const setShouldIgnoreUpdateAvilable = (ignore: boolean): GlobalActionTypes => ({
    type: GlobalActions.SET_SHOULD_IGNORE_AVAILABLE_UPDATE,
    payload: ignore
})

export const setShowParticipantJoinedModal = (showParticipantJoinedModal: boolean): GlobalActionTypes => ({
    type: GlobalActions.SET_SHOW_PARTICIPANT_JOINED_MODAL,
    payload: showParticipantJoinedModal
})
